<div [ngClass]="{'overlay_container_inside':recordLockService.isLocked}"
     *ngIf="recordLockService.isLocked && (recordLockService.searchRecordLock | json) != '{}'">
    <div class="overlay_message">
        <kendo-expansionpanel [title]="recordLockService.recordType.externalName + ' Record Locked'"
                              [disabled]="false"
                              [expanded]="true">
            <h2>{{recordLockService.recordType.externalName}} Record Locked</h2>
            <div>Edits for this {{recordLockService.recordType.externalName}} are currently locked.</div>
            <div><b>Locked By:</b> {{recordLockService.searchRecordLock.checkedOutByUserName}}</div>
            <div><b>Date Locked:</b> {{utilService.getTimeZoneDateAsLocalDate(recordLockService.searchRecordLock.dateCheckedOut, "UTC") | date:'medium'}}</div>
            <div><b>Lock Type:</b> {{recordLockService.searchRecordLock.recordLockTypeName}}</div>
            <div><b>Lock Source:</b> {{recordLockService.searchRecordLock.lockSource}}</div>
            <div class="float-right">
                <!--<button class="btn btn-danger" (click)="override()">Override Lock</button>
                <button class="btn btn-primary" (click)="cancel()">Cancel</button>-->
                <button class="btn btn-primary" (click)="cancel()">OK</button>
            </div>
        </kendo-expansionpanel>
    </div>
</div>
<div [ngClass]="{'overlay_container_inside':recordLockService.isLocked}"
     *ngIf="recordLockService.isLocked && recordLockService.searchRecordLockList.length > 0">
    <div class="overlay_message">
        <kendo-expansionpanel [title]="recordLockService.recordType.externalName + ' Record Locked'"
                              [disabled]="false"
                              [expanded]="true">
            <h2>{{recordLockService.recordType.externalName}} Record Locked</h2>
            <div>Edits for one or more {{recordLockService.recordType.externalName}} records are currently locked.</div>
            <div><b>IDs</b>: {{(recordLockService.recordLockedIDList.join(', '))}}</div>
            <!--<div><b>Locked By:</b> {{recordLockService.searchRecordLockList[0].checkedOutByUserName}}</div>
            <div><b>Date Locked:</b> {{utilService.getTimeZoneDateAsLocalDate(recordLockService.searchRecordLockList[0].dateCheckedOut, "UTC") | date:'medium'}}</div>
            <div><b>Lock Type:</b> {{recordLockService.searchRecordLockList[0].recordLockTypeName}}</div>
            <div><b>Lock Source:</b> {{recordLockService.searchRecordLockList[0].lockSource}}</div>-->
            <div class="float-right">
                <!--<button class="btn btn-danger" (click)="override()">Override Lock</button>
                <button class="btn btn-primary" (click)="cancel()">Cancel</button>-->
                <button class="btn btn-primary" (click)="cancel()">OK</button>
            </div>
        </kendo-expansionpanel>
    </div>
</div>
<div [ngClass]="{'overlay_container_inside':recordLockService.isTimeout}"
     *ngIf="recordLockService.isTimeout && (recordLockService.searchRecordLock | json) != '{}' && recordLockService.searchRecordLock.checkedOutByUserName">
    <div class="overlay_message">
        <kendo-expansionpanel [title]="recordLockService.recordType.externalName + ' Record Lock Timed Out'"
                              [disabled]="false"
                              [expanded]="true">
            <div>Record lock for this {{recordLockService.recordType.externalName}} timed out and needs to refresh.</div>
            <div><b>Locked By:</b> {{recordLockService.searchRecordLock.checkedOutByUserName}}</div>
            <div><b>Date Locked:</b> {{utilService.getTimeZoneDateAsLocalDate(recordLockService.searchRecordLock.dateCheckedOut, "UTC") | date:'medium'}}</div>
            <div><b>Lock Type:</b> {{recordLockService.searchRecordLock.recordLockTypeName}}</div>
            <div><b>Lock Source:</b> {{recordLockService.searchRecordLock.lockSource}}</div>
            <div class="float-right">
                <!--<button class="btn btn-danger" (click)="override()">Override Lock</button>
                <button class="btn btn-primary" (click)="cancel()">Cancel</button>-->
                <button class="btn btn-primary" (click)="continueTimeout()">OK</button>
            </div>
        </kendo-expansionpanel>
    </div>
</div>
<div [ngClass]="{'overlay_container_inside':recordLockService.isTimeout}"
     *ngIf="recordLockService.isTimeout && recordLockService.searchRecordLockList.length > 0">
    <div class="overlay_message">
        <kendo-expansionpanel [title]="recordLockService.recordType.externalName + ' Record Lock Timed Out'"
                              [disabled]="false"
                              [expanded]="true">
            <div>Record lock for one or more {{recordLockService.recordType.externalName}} records timed out and needs to refresh.</div>
            <!--<div><b>Locked By:</b> {{recordLockService.searchRecordLock.checkedOutByUserName}}</div>
            <div><b>Date Locked:</b> {{utilService.getTimeZoneDateAsLocalDate(recordLockService.searchRecordLock.dateCheckedOut, "UTC") | date:'medium'}}</div>
            <div><b>Lock Type:</b> {{recordLockService.searchRecordLock.recordLockTypeName}}</div>
            <div><b>Lock Source:</b> {{recordLockService.searchRecordLock.lockSource}}</div>-->
            <div class="float-right">
                <!--<button class="btn btn-danger" (click)="override()">Override Lock</button>
                <button class="btn btn-primary" (click)="cancel()">Cancel</button>-->
                <button class="btn btn-primary" (click)="continueTimeout()">OK</button>
            </div>
        </kendo-expansionpanel>
    </div>
</div>
<div [ngClass]="{'overlay_container_inside':recordLockService.isRefreshNeeded}"
     *ngIf="recordLockService.isRefreshNeeded && (recordLockService.searchRecordLock | json) != '{}' && recordLockService.searchRecordLock.checkedOutByUserName">
    <div class="overlay_message">
        <kendo-expansionpanel [title]="recordLockService.recordType.externalName + ' Record Lock Closed'"
                              [disabled]="false"
                              [expanded]="true">
            <div>Record lock for this {{recordLockService.recordType.externalName}} is closed and needs to refresh.</div>
            <div><b>Locked By:</b> {{recordLockService.searchRecordLock.checkedOutByUserName}}</div>
            <div><b>Date Locked:</b> {{utilService.getTimeZoneDateAsLocalDate(recordLockService.searchRecordLock.dateCheckedOut, "UTC") | date:'medium'}}</div>
            <div><b>Lock Type:</b> {{recordLockService.searchRecordLock.recordLockTypeName}}</div>
            <div><b>Lock Source:</b> {{recordLockService.searchRecordLock.lockSource}}</div>
            <div class="float-right">
                <!--<button class="btn btn-danger" (click)="override()">Override Lock</button>
                <button class="btn btn-primary" (click)="cancel()">Cancel</button>-->
                <button class="btn btn-primary" (click)="continueRefresh()">OK</button>
            </div>
        </kendo-expansionpanel>
    </div>
</div>
